import React from 'react';

export interface FilterState {
  length: string;
  styles: string[];
  purposes: string[];
}

interface FiltersProps {
  filters: FilterState;
  onFilterChange: (filters: FilterState) => void;
}

const styleOptions = [
  { id: 'formal', label: 'Formal', emoji: '👔' },
  { id: 'casual', label: 'Casual', emoji: '👕' },
  { id: 'creative', label: 'Creative', emoji: '🎨' },
  { id: 'personal', label: 'Personal', emoji: '🤝' },
];

const purposeOptions = [
  { id: 'job', label: 'Job Application', emoji: '💼' },
  { id: 'career-change', label: 'Career Change', emoji: '🔄' },
  { id: 'internship', label: 'Internship', emoji: '🎓' },
  { id: 'freelance', label: 'Freelance', emoji: '🚀' },
];

export function Filters({ filters, onFilterChange }: FiltersProps) {
  const handleLengthChange = (value: string) => {
    onFilterChange({ ...filters, length: value });
  };

  const handleStyleToggle = (style: string) => {
    const newStyles = filters.styles.includes(style)
      ? filters.styles.filter(s => s !== style)
      : [...filters.styles, style];
    onFilterChange({ ...filters, styles: newStyles });
  };

  const handlePurposeToggle = (purpose: string) => {
    const newPurposes = filters.purposes.includes(purpose)
      ? filters.purposes.filter(p => p !== purpose)
      : [...filters.purposes, purpose];
    onFilterChange({ ...filters, purposes: newPurposes });
  };

  return (
    <div className="space-y-3">
      <div>
        <label className="block text-xs font-medium text-gray-700 mb-1">
          Length
        </label>
        <div className="flex justify-between text-xs text-gray-600">
          <button
            onClick={() => handleLengthChange('short')}
            className={`px-2 py-1 rounded ${
              filters.length === 'short'
                ? 'bg-blue-100 text-blue-800'
                : 'bg-gray-100 hover:bg-gray-200'
            }`}
          >
            Short
          </button>
          <button
            onClick={() => handleLengthChange('medium')}
            className={`px-2 py-1 rounded ${
              filters.length === 'medium'
                ? 'bg-blue-100 text-blue-800'
                : 'bg-gray-100 hover:bg-gray-200'
            }`}
          >
            Medium
          </button>
          <button
            onClick={() => handleLengthChange('long')}
            className={`px-2 py-1 rounded ${
              filters.length === 'long'
                ? 'bg-blue-100 text-blue-800'
                : 'bg-gray-100 hover:bg-gray-200'
            }`}
          >
            Long
          </button>
        </div>
      </div>

      <div>
        <label className="block text-xs font-medium text-gray-700 mb-1">
          Style
        </label>
        <div className="flex flex-wrap gap-1">
          {styleOptions.map((style) => (
            <button
              key={style.id}
              onClick={() => handleStyleToggle(style.id)}
              className={`px-3 py-1 rounded text-xs flex items-center space-x-1 ${
                filters.styles.includes(style.id)
                  ? 'bg-blue-100 text-blue-800'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <span>{style.emoji}</span>
              <span>{style.label}</span>
            </button>
          ))}
        </div>
      </div>

      <div>
        <label className="block text-xs font-medium text-gray-700 mb-1">
          Purpose
        </label>
        <div className="flex flex-wrap gap-1">
          {purposeOptions.map((purpose) => (
            <button
              key={purpose.id}
              onClick={() => handlePurposeToggle(purpose.id)}
              className={`px-3 py-1 rounded text-xs flex items-center space-x-1 ${
                filters.purposes.includes(purpose.id)
                  ? 'bg-blue-100 text-blue-800'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <span>{purpose.emoji}</span>
              <span>{purpose.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}